<template>
  <div
    v-if="!loading"
    id="actionPlanMain"
  >
    <div
      v-if="role_type === 'coach'"
      class="mainCard"
    >
      <el-page-header
        title="Go Back"
        :content="null"
        @back="$router.push({
          name: 'myLeaderDetail',
          params: {id: $route.params.id}
        }).catch((err) => {})"
      />
    </div>

    <OverviewMain
      v-if="actionPlans"
      :action-plans="actionPlans"
      :leader-uuid="role_type === 'coach' ? $route.params.id : null"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/api';
import OverviewMain from './overview/OverviewMain.vue';

export default {
  components: {
    OverviewMain,
  },

  data() {
    return {
      actionPlans: null,
      loading: true,
    };
  },

  computed: {
    ...mapState({
      role_type: (state) => state.user.user.role_type,
    }),
  },

  created() {
    this.getActionPlans();
  },

  methods: {
    async getActionPlans() {
      try {
        let response;
        let ap;
        if (this.role_type === 'coach') {
          // we ignore action plan validation for coach
          ap = {};
        } else {
          response = await api.getActionPlan();
          ap = response.data;
          if (!ap.lga1 && !ap.lga2) {
            this.$router.push({ name: 'actionPlanSetUp' }).catch(() => {});
            return;
          }
        }

        this.actionPlans = ap;
        this.loading = false;
      } catch (err) {
        this.loading = false;
        if (err.msg) {
          this.$message.error(err.msg);
        }
        this.$router.push({ name: 'dashboard' }).catch(() => {});
      }
    },
  },
};
</script>
